import DisabledChip from "../DisabledChip"
import FavoriteIcon from "@mui/icons-material/Favorite"
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder"
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline"
import { Box, IconButton } from "@mui/material"
import Typography from "@mui/material/Typography"
import { Tag, TagPresets } from "components/tag"
import { Text } from "components/text"
import useHeadingStyles from "hooks/useHeadingStyles"
import React, { useState, useEffect } from "react"
import { makeStyles } from "tss-react/mui-compat"

const TagStyle: React.CSSProperties = {
  position: "absolute",
  bottom: 0,
  right: 0,
  left: "auto",
  top: "auto",
}

const useStyles = makeStyles()(
  (_theme) => ({
    root: {
      padding: 0,
    },
    hiddenFav: {
      opacity: "0%",
      visibility: "hidden",
    },
    playButton: {
      position: "absolute",
      top: "50%",
      bottom: "auto",
      left: "50%",
      right: "auto",
      transform: "translateY(-50%) translateX(-50%)",
    },
    playButtonIcon: {
      fontSize: "80px",
      color: "white",
    },
    backgroundImage: {
      display: "flex",
      position: "relative",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      minHeight: 300,
      width: "100%",
    },
    headerFooter: {
      position: "absolute",
      bottom: 0,
      left: 0,
      height: "100%",
      width: "100%",
      background: "linear-gradient(180deg, rgba(78, 86, 89, 0) 0%, #262b2d 100%)",
      justifyContent: "space-between",
      alignItems: "flex-end",
    },
  }),
)

interface IProfileHeader {
  tagText?: string
  tagPreset?: TagPresets
  imageURL?: string
  isLiked?: boolean
  subtitle?: string
  title?: string
  videoURL?: string
  onPress?: () => void
  onSubtitlePress?: () => void
  onRightIconPress?: (e: React.MouseEvent) => void
  disabled?: boolean
}

export const ProfileHeader = (props: IProfileHeader) => {
  const {
    tagText,
    tagPreset,
    videoURL,
    isLiked = false,
    imageURL,
    title,
    subtitle,
    onPress,
    onSubtitlePress,
    onRightIconPress,
    disabled = false,
  } = props

  const [liked, setLiked] = useState(isLiked)

  const { classes, cx } = useStyles()
  const { classes: headingClasses } = useHeadingStyles()

  useEffect(() => {
    setLiked(isLiked)
  }, [isLiked])

  // @ts-ignore PT - #180597146
  const onRightPress = (evt) => {
    setLiked(!liked)
    // @ts-ignore
    onRightIconPress(evt)
  }

  return (
    <Box
      className={classes.backgroundImage}
      onClick={onPress}
      height={["300px", null, null, "500px"]}
      style={{
        cursor: onPress ? "pointer" : "default",
        backgroundImage: `url(${imageURL})`,
      }}>
      <Box className={classes.headerFooter} pb={[3]} px={[3, 3, 4]}>
        <Box display="flex" flexDirection="column">
          {Boolean(subtitle) && (
            <Box mb={[2]}>
              <Text
                style={{ color: "white" }}
                preset="bodyMediumPrimary"
                text={subtitle}
                onPress={onSubtitlePress}
              />
            </Box>
          )}
          {Boolean(title) && (
            <Box>
              <Typography variant="h1" className={headingClasses.h1alt}>
                {title}
              </Typography>
            </Box>
          )}
        </Box>
        <Box>
          {disabled && <DisabledChip />}
          {Boolean(onRightIconPress) && (
            <IconButton
              className={cx(classes.root, disabled ? classes.hiddenFav : "")}
              onClick={onRightPress}
              aria-label={`${isLiked ? "Unfavorite" : "Favorite"} ${title}`}
              size="large">
              {liked ? (
                <FavoriteIcon color="error" fontSize="large" />
              ) : (
                <FavoriteBorderIcon style={{ color: "white" }} fontSize="large" />
              )}
            </IconButton>
          )}
          {Boolean(tagText) && <Tag preset={tagPreset} text={tagText} style={TagStyle} />}
        </Box>
      </Box>
      {Boolean(videoURL) && (
        <IconButton aria-label="Play Video" className={classes.playButton} size="large">
          <PlayCircleOutlineIcon aria-hidden={true} className={classes.playButtonIcon} />
        </IconButton>
      )}
    </Box>
  )
}
